import { render, staticRenderFns } from "./ProductsPages.vue?vue&type=template&id=db48bcca&scoped=true"
import script from "./ProductsPages.vue?vue&type=script&lang=js"
export * from "./ProductsPages.vue?vue&type=script&lang=js"
import style0 from "./ProductsPages.vue?vue&type=style&index=0&id=db48bcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db48bcca",
  null
  
)

export default component.exports